import React, { useEffect, useState } from 'react';
import { VehiculosAdapter } from '../../../../../infraestructure/persistence/rest/VehiculosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import SelectorVehiculos from './selector';

export const SelectorVehiculosContainer = (props: any) => {
  
	const api = new VehiculosAdapter();
	const { exceptionError, resultError } = useNotifications();
	let [vehiculos, setVehiculos] = useState<any>([])
	let result: any;
  
  useEffect(()=>{
    getVehiculos();
  },[])

	const getVehiculos = async () => {
		try {
			result = await api.ListarVehiculos();
			if(result.data && result.data!=="")
			{
				setVehiculos([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
  };

  return <SelectorVehiculos {...props} data={vehiculos}/>
};

export default SelectorVehiculosContainer;